import { Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {Observable} from 'rxjs';

export interface DrawerOpenOptions<T = any> {
  data?: Partial<T>;
  width?: string;
}

export interface IDrawerRef<T = any>  {
  close(result?: T): void;
  afterClosed(): Observable<T | undefined>;
}

@Injectable({
  providedIn: 'root',
})
export class DrawerService {

  private DrawerRefClass = class DrawerRef<T = any> implements IDrawerRef<T>{
    private dialogContainer;
    constructor(private dialogRef: MatDialogRef<any, T>) {
    this.dialogContainer = this.dialogRef.componentInstance?.elementRef?.nativeElement
        || document.querySelector('.side-drawer-service');
    }

    close(result?: T): void {
      this.dialogContainer.classList.add('closing');
      setTimeout(() => {this.dialogRef.close(result);}, 200);
    }

    afterClosed(): Observable<T | undefined> {
      return this.dialogRef.afterClosed();
    }
  };

  constructor(private dialog: MatDialog) {}
  open<T>(
    component: Type<T>,
    options: DrawerOpenOptions<T> = {}
  ): IDrawerRef<T>  {
    const dialogRef = this.dialog.open(component, {
      height: '100vh',
      width: options.width ?? '1084px',
      position: { right: '0' },
      panelClass: 'side-drawer-service',
      autoFocus: false,
      restoreFocus: false,
      data: {
        component,
        data: options.data,
      },
    });
    return new this.DrawerRefClass<T>(dialogRef);
  }

  close(): void {
    this.dialog.closeAll();
  }
}
